/* eslint-disable react/prop-types */

import { Input } from '../../../components'
import { ListTable } from '../../../components/ListTable'
import { Row } from '../../../components/ListTable/Row'
import { TableItem } from '../../../components/ListTable/TableItem'
import styles from './styles.module.css'
import { Switch } from 'antd'
import {
  // CircleFacebook,
  // CloundArrowUp,
  Eye,
  Gear,
  NavigateArrowLeft,
  NavigateArrowRigth,
  // Instagram,
  // Linkedin,
  // Pinterest,
  // TikTok,
  Trash,
  // Twitter,
} from '../../../assets/svgs/icons'
import { useEffect, useState } from 'react'
import { SelectSquare } from '../../../components/Select/SelectSquare/SelectSquare'
import { AnimatePresence, motion } from 'framer-motion'
// import { useNavigate } from 'react-router-dom'
import { SubscriptionService, TargetAudienceService } from '../../../services'
import { getAllgenderService } from '../../../services/genderService'
import {
  getAllLocationStatesService,
  getAllRegionsLocationService,
} from '../../../services/locationsService'
import {
  getAllSocialClassService,
  postSocialClassHasTargetAudiences,
  deleteSocialClassHasTargetAudiences,
  postEducationLevelHasTargetAudiences,
  deleteEducationLevelHasTargetAudiences,
} from '../../../services/socialClassService'
import { getAllEducationLevelService } from '../../../services/educationService'
import {
  notifyErrorCustom,
  notifySuccessCustom,
  notifyWarningCustom,
} from '../../../utils/notify'
import * as yup from 'yup'
import { Loading } from '../../../components/Loading'
import { MultiplySelectSquare } from '../../../components/Select/MultiplySelectSquare'
import { useTranslation } from 'react-i18next'

const STEPS = {
  STEP_TARGET_AUDIENCE_VIEW: 'targetAudienceView',
}

function TargetAudienceList({ setStep, setTargetAudienceItem, clientData }) {
  const { t } = useTranslation()
  const headers = [
    `${t('target_audience_table_name')}`,
    `${t('target_audience_table_social_class')}`,
    `${t('target_audience_table_state')}`,
    `${t('target_audience_table_region')}`,
    `${t('target_audience_table_action')}`,
  ]


  // const [isPinterest, setIsPinterest] = useState(false)
  // const [isLinkedin, setIsLinkedin] = useState(false)
  // const [isFacebook, setIsFacebook] = useState(false)
  // const [isInstagram, setIsInstagram] = useState(false)
  // const [isTiktok, setIsTiktok] = useState(false)
  // const [isTwitter, setIsTwitter] = useState(false)
  const storage = window.localStorage

  const [locationsStatesOptions, setLocationsStatesOptions] = useState([
    { label: '', value: '' },
  ])
  const [genderOptions, setGenderOptions] = useState([{ label: '', value: '' }])

  const [educationLevelOptions, setEducationLevelOptions] = useState([
    { label: '', value: '' },
  ])
  const [socialClassOptions, setSocialClassOptions] = useState([
    { label: '', value: '' },
  ])
  const [regionLocationOptions, setRegionLocationOptions] = useState([
    { label: '', value: '' },
  ])

  const [tagetAudienceData, setTargetAudienceData] = useState({})

  // const navigation = useNavigate()

  const [expanded, setExpanded] = useState(false)

  const [dataList, setDataList] = useState([])


  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 8;

  const totalPages = Math.ceil(dataList.length / itemsPerPage);

  const paginatedTagetAudience = dataList.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );


  const [loading, setLoading] = useState(false)

  const handleExpandForm = async (params) => {
    if (!params) {
      const businessTargetAudienceCount =
        await TargetAudienceService.getAllTargetAudienceCount()
      const userSubscription = await SubscriptionService.getSubscriptionByUser()

      if (
        userSubscription.data.length <= 0 &&
        businessTargetAudienceCount.data.count >= 30
      ) {
        notifyWarningCustom(
          t(
            'target_audience_plan_validation_limitst.notifications.client_limit'
          )
        )
        return
      } else if (userSubscription.data.length > 0) {
        const index = await userSubscription.data[0].Plan.PlanItems.findIndex(
          (item) => item.type === 'target_audience_quantity'
        )
        const quantityTargetAudience =
          userSubscription.data[0].Plan.PlanItems[index]?.quantity

        if (
          businessTargetAudienceCount.data.count >= quantityTargetAudience &&
          quantityTargetAudience != null
        ) {
          notifyWarningCustom(t('target_audience_plan_validation_limit'))
          return
        }
      }
    }
    if (!params) {
      setTargetAudienceData({})
    }

    setTargetAudienceData(params)
    setExpanded(!expanded)
  }

  const handleNavigate = (targetAudienceItem) => {
    setTargetAudienceItem(targetAudienceItem)
    setStep(STEPS.STEP_TARGET_AUDIENCE_VIEW)
    // navigation(route, { state: { targetAudienceItem } })
  }

  const handleChecked = async (data) => {
    let uuid = data?.uuid

    data.educationLevelId = data.educationLevelId ?? -1
    data.onlinePurchaseFrequencyId = data.onlinePurchaseFrequencyId ?? -1
    data.targetAudienceBrandsId = data.targetAudienceBrandsId ?? -1
    data.guestId = data.guestId ?? ''
    data.stateId = data.stateId ?? -1
    data.regionId = data.regionId ?? -1
    data.city = data.city ?? ''
    data.businessClientId = data.businessClientId ?? ''
    data.profession = data.profession ?? ''

    let newData = { ...data }

    delete newData.uuid
    delete newData.createdAt
    delete newData.updatedAt
    delete newData.deletedAt
    delete newData.userAccountId
    delete newData.genderValue

    delete newData.userAccountId

    delete newData.educationLevelItems
    delete newData.socialClassItems

    delete newData.SocialClassHasTargetAudience
    delete newData.EducationLevelHasTargetAudience
    delete newData.educationLevelValue
    delete newData.socialClassValue
    delete newData.stateValue
    delete newData.educationLevelId
    delete newData.regionValue

    if (JSON.parse(window.localStorage.getItem('userData')).guestUserId) {
      newData.guestId = JSON.parse(
        window.localStorage.getItem('userData')
      ).guestUserId
    }
    if (!clientData?.uuid) {
      delete newData.businessClientId
    }
    setLoading(true)

    const { responseStatus } = await TargetAudienceService.putTargetAudience(
      uuid,
      { ...newData, enabled: !newData.enabled }
    )
    setLoading(false)

    if (responseStatus === 200 || responseStatus === 204) {
      loadTargetAudienceData()
      notifySuccessCustom('Status alterado com sucesso!')
    } else {
      notifyErrorCustom('Não foi possível alterar o status!')
    }
  }

  const [isNameValid, setIsNameValid] = useState(true)
  const handleChange = (k, v) => {
    setTargetAudienceData((prevState) => ({ ...prevState, [k]: v }))

    if (k === 'name') {
      if (v.trim() === '') {
        setIsNameValid(false)
      } else {
        setIsNameValid(true)
      }
    }
  }

  useEffect(() => {
    loadTargetAudienceData()
    loadDropdownsData()
    setExpanded(false)
  }, [clientData])

  const loadTargetAudienceData = async () => {
    if (!clientData?.uuid) {
      setLoading(true)
      const { data, responseStatus } =
        await TargetAudienceService.getAllTargetAudienceByNotClientIdList(
          storage.i18nextLng == 'en' ? storage.i18nextLng : 'ptBR'
        )
      setLoading(false)
      if (responseStatus === 200) {
        setDataList(data)
      }
    } else {
      setLoading(true)
      const { data, responseStatus } =
        await TargetAudienceService.getAllTargetAudienceByClientId(
          clientData?.uuid
        )
      setLoading(false)
      if (responseStatus === 200) {
        setDataList(data)
      }
    }
  }

  const loadDropdownsData = async () => {
    // faça chamada dos serviços
    const { data: stateLocationData, responseStatus: stateLocationStatus } =
      await getAllLocationStatesService()

    const { data: regionLocationData, responseStatus: regionLocationStatus } =
      await getAllRegionsLocationService()

    const { data: genderData, responseStatus: genderStatus } =
      await getAllgenderService()

    const { data: socialClassData, responseStatus: socialClassStatus } =
      await getAllSocialClassService()

    const { data: educationLevelData, responseStatus: educationLevelStatus } =
      await getAllEducationLevelService()

    //altere estados
    if (stateLocationStatus === 200)
      setLocationsStatesOptions(
        stateLocationData.map((e) => ({ label: e.name, value: e.id }))
      )

    if (regionLocationStatus === 200)
      setRegionLocationOptions(
        regionLocationData.map((e) => ({
          label: storage.i18nextLng == 'en' ? e.nameNr : e.name,
          value: e.id,
        }))
      )

    if (genderStatus === 200)
      setGenderOptions(
        genderData.map((e) => ({
          label: storage.i18nextLng == 'en' ? e.nameEn : e.name,
          value: e.id,
        }))
      )
    if (socialClassStatus === 200)
      setSocialClassOptions(
        socialClassData.map((e) => ({
          label: storage.i18nextLng == 'en' ? e.nameEn : e.name,
          value: e.id,
        }))
      )
    if (educationLevelStatus === 200)
      setEducationLevelOptions(
        educationLevelData.map((e) => ({
          label: storage.i18nextLng == 'en' ? e.nameEn : e.name,
          value: e.id,
        }))
      )
  }

  const dataScheema = yup.object().shape({
    name: yup.string().required('o campo nome é obrigatorio'),
    genderId: yup.number().required('selecione um gênero'),
    // city: yup.string().required('digite a cidade'),
    // regionId: yup.number().required('selecione a região'),
    // stateId: yup.number().required('selecione o estado'),
    // profession: yup.string().required('preencha o campo profissão'),
    // socialClassId: yup.number().required('selecione a classe social'),
    // educationLevelId: yup
    //   .number()
    //   .required('selecione um nivel de escolaridade'),
  })

  //valide dados com base no scheema
  const validateFields = async (dataToValidate) => {
    return await dataScheema
      .validate(dataToValidate)
      .then(() => {
        return true
      })
      .catch((error) => {
        notifyErrorCustom(error.message)
        return false
      })
  }

  const handleSave = async () => {
    const isValid = await validateFields(tagetAudienceData)
    if (!isValid) {
      setLoading(false)
      return
    }

    if (tagetAudienceData?.uuid) {
      tagetAudienceData.educationLevelId =
        tagetAudienceData.educationLevelId ?? -1
      tagetAudienceData.onlinePurchaseFrequencyId =
        tagetAudienceData.onlinePurchaseFrequencyId ?? -1
      tagetAudienceData.targetAudienceBrandsId =
        tagetAudienceData.targetAudienceBrandsId ?? -1
      tagetAudienceData.guestId = tagetAudienceData.guestId ?? ''
      tagetAudienceData.stateId = tagetAudienceData.stateId ?? -1
      tagetAudienceData.regionId = tagetAudienceData.regionId ?? -1
      tagetAudienceData.city = tagetAudienceData.city ?? ''
      tagetAudienceData.businessClientId =
        tagetAudienceData.businessClientId ?? ''
      tagetAudienceData.profession = tagetAudienceData.profession ?? ''

      const { uuid, ...rest } = { ...tagetAudienceData }

      delete rest.createdAt
      delete rest.updatedAt
      delete rest.deletedAt
      delete rest.userAccountId
      delete rest.genderValue

      delete rest.SocialClassHasTargetAudience
      delete rest.genderId.EducationLevelHasTargetAudience
      delete rest.educationLevelValue
      delete rest.socialClassValue
      // delete rest.educationLevelValue
      // delete rest.socialClassValue
      // delete rest.stateValue
      // delete rest.businessClientId

      delete rest.educationLevelItems
      delete rest.socialClassItems
      delete rest.EducationLevelHasTargetAudience
      delete rest.stateValue
      delete rest.educationLevelId
      delete rest.regionValue

      if (JSON.parse(window.localStorage.getItem('userData')).guestUserId) {
        rest.guestId = JSON.parse(
          window.localStorage.getItem('userData')
        ).guestUserId
      }

      setLoading(true)

      for (
        let i = 0;
        i < tagetAudienceData?.EducationLevelHasTargetAudience?.length;
        i++
      ) {
        await deleteEducationLevelHasTargetAudiences(
          tagetAudienceData?.EducationLevelHasTargetAudience[i]?.uuid
        )
      }

      for (
        let i = 0;
        i < tagetAudienceData?.SocialClassHasTargetAudience?.length;
        i++
      ) {
        await deleteSocialClassHasTargetAudiences(
          tagetAudienceData?.SocialClassHasTargetAudience[i]?.uuid
        )
      }

      const { responseStatus } = await TargetAudienceService.putTargetAudience(
        uuid,
        rest
      )

      setLoading(false)

      if (responseStatus === 200 || responseStatus === 204) {
        const { educationLevelItems, socialClassItems } = tagetAudienceData

        for (let i = 0; i < educationLevelItems?.length; i++) {
          const body = {
            targetAudienceId: uuid,
            educationLevelId: educationLevelItems[i].value,
          }

          const saveEducationLevel = await postEducationLevelHasTargetAudiences(
            body
          )
        }

        for (let i = 0; i < socialClassItems?.length; i++) {
          const body = {
            targetAudienceId: uuid,
            socialClassId: socialClassItems[i].value,
          }

          const saveSocialClass = await postSocialClassHasTargetAudiences(body)
        }

        setExpanded(!expanded)
      }
    } else {
      setLoading(true)

      let newBody = { ...tagetAudienceData }

      const { educationLevelItems, socialClassItems } = { ...tagetAudienceData }

      delete newBody.educationLevelItems
      delete newBody.socialClassItems

      let guestId = JSON.parse(
        window.localStorage.getItem('userData')
      ).guestUserId

      if (clientData?.uuid && guestId) {
        newBody = {
          ...tagetAudienceData,
          businessClientId: clientData?.uuid,
          guestId,
        }
      }
      if (guestId) {
        newBody = { ...tagetAudienceData, guestId: guestId }
      }

      const { responseStatus, data } =
        await TargetAudienceService.postTargetAudience({
          ...newBody,
        })

      setLoading(false)

      if (responseStatus === 200 || responseStatus === 204) {
        for (let i = 0; i < socialClassItems?.length; i++) {
          const body = {
            targetAudienceId: data?.uuid,
            socialClassId: socialClassItems[i].value,
          }

          const saveSocialClass = await postSocialClassHasTargetAudiences(body)
        }

        for (let i = 0; i < educationLevelItems?.length; i++) {
          const body = {
            targetAudienceId: data?.uuid,
            educationLevelId: educationLevelItems[i].value,
          }

          const saveEducationLevel = await postEducationLevelHasTargetAudiences(
            body
          )

          // console.log('saveEducationLevel', saveEducationLevel)

          // console.log('body', body)
        }

        setExpanded(!expanded)
      }
    }
    setTargetAudienceData({})
    loadTargetAudienceData()
  }

  const handleDeliteItemList = async (id) => {
    setLoading(true)

    const { responseStatus } = await TargetAudienceService.deleteTargetAudience(
      id
    )

    setLoading(false)

    if (responseStatus === 200 || responseStatus === 204) {
      notifySuccessCustom('Publico alvo deletado com sucesso!')
    }
    loadTargetAudienceData()
  }

  return (
    <div className={styles.container_page}>
      <Loading enable={loading} />
      <div className={styles.header_page}>
        <div className={styles.title_new_posts}>
          <p className={styles.title_new_posts_label}>
            {t('target_audience_title')}
          </p>
          <p className={styles.title_new_posts_title}>
            {t('target_audience_title_text')}
          </p>
        </div>
        <div>
          <button
            className={styles.button_new_user}
            onClick={() => handleExpandForm()}
          >
            {expanded
              ? `${t('target_audience_title_cancel_button')}`
              : `${t('target_audience_title_new_user_button')}`}
          </button>
        </div>
      </div>

      <div className={styles.container_content}>
        <AnimatePresence initial={false}>
          {expanded && (
            <motion.div
              // key={expanded}
              initial={{ opacity: 0 }}
              transition={{ duration: 0.3 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              className={styles.container_form}
            >
              <p className={styles.title_new_posts_title}>
                {t('target_audience_new_target_audience')}
              </p>
              <div className={styles.container_content_form}>
                <div className={styles.box_input_form}>
                  <label className={styles.label_input_form}>
                    {t('target_audience_new_target_audience_register_name')}
                  </label>
                  {!isNameValid && (
                    <p style={{ color: 'red' }}>
                      O campo Nome não pode estar vazio.
                    </p>
                  )}
                  <Input
                    id="name"
                    onChange={({ target: { id, value } }) =>
                      handleChange(id, value)
                    }
                    defaultValue={tagetAudienceData?.name}
                  />
                </div>

                <div className={styles.box_input_form}>
                  <label className={styles.label_input_form}>
                    {t('target_audience_new_target_audience_register_gen')}
                  </label>

                  <SelectSquare
                    htmlFor="select"
                    arrowDirection="down"
                    placeholder={t(
                      'target_audience_new_target_audience_register_input_placeholder'
                    )}
                    defaultSelected={genderOptions.find(
                      (e) => e.value === tagetAudienceData?.genderId
                    )}
                    options={genderOptions}
                    onClickItem={({ value }) => handleChange('genderId', value)}
                  />
                </div>
                <div className={styles.box_input_form}>
                  <label className={styles.label_input_form}>
                    {t(
                      'target_audience_new_target_audience_register_education'
                    )}
                  </label>

                  <MultiplySelectSquare
                    htmlFor="select"
                    variante="grey"
                    arrowDirection="down"
                    placeholder={t(
                      'target_audience_new_target_audience_register_level_education_placeholder'
                    )}
                    defaultSelected={() => {
                      if (tagetAudienceData?.educationLevelValue?.length > 0) {
                        let itemReturn =
                          tagetAudienceData?.educationLevelValue.map((e) => ({
                            label: e,
                            value: educationLevelOptions.find(
                              (el) => el.label === e
                            )?.value,
                          }))

                        handleChange('educationLevelItems', itemReturn)
                        return itemReturn
                      }
                      return []
                    }}
                    options={educationLevelOptions}
                    onClickItem={(value) => {
                      handleChange('educationLevelItems', value)
                    }}
                  />
                </div>

                <div className={styles.box_input_form}>
                  <label className={styles.label_input_form}>
                    {t(
                      'target_audience_new_target_audience_register_social_class'
                    )}
                  </label>

                  <MultiplySelectSquare
                    htmlFor="select"
                    variante="grey"
                    arrowDirection="down"
                    placeholder={t(
                      'target_audience_new_target_audience_register_social_status_placeholder'
                    )}
                    defaultSelected={() => {
                      if (tagetAudienceData?.socialClassValue?.length > 0) {
                        let itemReturn =
                          tagetAudienceData?.socialClassValue.map((e) => ({
                            label: e,
                            value: socialClassOptions.find(
                              (el) => el.label === e
                            )?.value,
                          }))

                        handleChange('socialClassItems', itemReturn)

                        return itemReturn
                      }
                      return []
                    }}
                    options={socialClassOptions}
                    onClickItem={(value) => {
                      handleChange('socialClassItems', value)
                    }}
                  />
                </div>
                <div className={styles.box_input_form}>
                  <label className={styles.label_input_form}>
                    {' '}
                    {t(
                      'target_audience_new_target_audience_register_profession'
                    )}
                  </label>
                  <Input
                    id="profession"
                    onChange={({ target: { id, value } }) =>
                      handleChange(id, value)
                    }
                    defaultValue={
                      tagetAudienceData ? tagetAudienceData?.profession : ''
                    }
                  />
                </div>

                <div className={styles.container_input_fom}>
                  <div className={styles.box_input_form}>
                    <label className={styles.label_input_form}>
                      {' '}
                      {t('target_audience_new_target_audience_register_region')}
                    </label>
                    <SelectSquare
                      htmlFor="select"
                      arrowDirection="down"
                      placeholder={
                        tagetAudienceData
                          ? tagetAudienceData?.regionId
                          : t(
                            'target_audience_new_target_audience_register_input_placeholder'
                          )
                      }
                      defaultSelected={regionLocationOptions.find(
                        (e) => e.value === tagetAudienceData?.regionId
                      )}
                      options={regionLocationOptions}
                      onClickItem={({ value }) =>
                        handleChange('regionId', value)
                      }
                    />
                  </div>

                  <div className={styles.box_input_form}>
                    <label className={styles.label_input_form}>
                      {' '}
                      {t('target_audience_new_target_audience_register_state')}
                    </label>
                    <SelectSquare
                      htmlFor="select"
                      arrowDirection="down"
                      placeholder={
                        tagetAudienceData
                          ? tagetAudienceData?.stateId
                          : t(
                            'target_audience_new_target_audience_register_input_placeholder'
                          )
                      }
                      defaultSelected={locationsStatesOptions.find(
                        (e) => e.value === tagetAudienceData?.stateId
                      )}
                      options={locationsStatesOptions}
                      onClickItem={({ value }) =>
                        handleChange('stateId', value)
                      }
                    />
                  </div>

                  <div className={styles.box_input_form}>
                    <label className={styles.label_input_form}>
                      {' '}
                      {t('target_audience_new_target_audience_register_city')}
                    </label>
                    <Input
                      id="city"
                      onChange={({ target: { id, value } }) =>
                        handleChange(id, value)
                      }
                      defaultValue={
                        tagetAudienceData ? tagetAudienceData?.city : ''
                      }
                    />
                  </div>
                </div>
                <div className={styles.box_button_save}>
                  <button
                    className={styles.button_save}
                    onClick={() => {
                      setLoading(true)
                      handleSave()
                    }}
                  >
                    {t('user_list_new_user_register_butom_save')}
                  </button>
                </div>
              </div>
            </motion.div>
          )}
        </AnimatePresence>

        {expanded === false && (
          <motion.div
            // key={expanded}
            initial={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          >
            <ListTable headers={headers}>
              {paginatedTagetAudience?.map((targetAudience, index) => (
                // eslint-disable-next-line react/jsx-key
                <Row key={index}>
                  <TableItem>
                    <div className={styles.box_name_target_audience}>
                      <div>
                        <p className={styles.name_target_audience_text}>
                          {targetAudience?.name}
                        </p>
                      </div>
                    </div>
                  </TableItem>
                  <TableItem>
                    {targetAudience?.socialClassValue.map((e) => e).join(', ')}
                  </TableItem>
                  <TableItem>
                    <span className={styles.bold}>
                      {targetAudience?.stateValue}
                    </span>
                  </TableItem>
                  <TableItem>
                    <span className={styles.bold}>
                      {targetAudience?.regionValue}
                    </span>
                  </TableItem>
                  <TableItem style={{ maxWidth: 170 }}>
                    <div className={styles.last_column}>
                      <div className={styles.icons_container}>
                        <div className={styles.icon}>
                          <div className={styles.box_action_icon}>
                            <Switch
                              size="small"
                              style={{
                                backgroundColor: targetAudience?.enabled
                                  ? 'black'
                                  : '',
                              }}
                              checked={targetAudience?.enabled}
                              onClick={() => handleChecked(targetAudience)}
                            />
                          </div>

                          <div
                            className={styles.box_action_icon}
                            onClick={() => handleExpandForm(targetAudience)}
                          >
                            <Gear color={'#000'} />
                          </div>

                          <div
                            className={styles.box_action_icon}
                            onClick={() => handleNavigate(targetAudience)}
                          >
                            <Eye color={'#000'} />
                          </div>

                          <div
                            className={styles.box_action_icon}
                            onClick={() =>
                              handleDeliteItemList(targetAudience.uuid)
                            }
                          >
                            <Trash color={'#000'} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </TableItem>
                </Row>
              ))}
            </ListTable>
          </motion.div>
        )}
        {paginatedTagetAudience.length > 8 && (
          <div className={styles.pagination}>
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              <NavigateArrowLeft color={'#C4CDD5'}/>
            </button>
            <span>Página {currentPage} de {totalPages}</span>
            <button
              onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={currentPage === totalPages}
            >
              <NavigateArrowRigth color={'#C4CDD5'}/>
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

export default TargetAudienceList
